export default "__VITE_ASSET__pcIdyZ3N__"